const data = [
  {
    id: '1',
    title: 'Edencommerce',
    description:
      'Edencommerce is an ecommerce store that deals on clothings and other material assiorcies. Its interactive homepage reveals how the products’ cutting-edge features and durability help aviators from different generations adjust to time zones and travel in extreme conditions.',
    image: {
      src: 'https://edencommerce.netlify.app/imags/card4.png',
      // placeholderSrc:
      //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://edencommerce.netlify.app/',
    },
    technologies: [
      '#html',
      '#css',
      '#web-app',
      // '#mobx-state-tree',
      // '#expo',
      // '#i18next',
      // '#react-navigation',
      // '#sentry',
    ],
  },
  {
    id: '2',
    title: 'Edenfigma',
    description:
      'Edenfigma is a figma design that was translated into a website using codes.It is a training website that specialises in fostering skills development, providing top-notch training programmes, eLearning development and promoting empowerment initiatives.',
    image: {
      src: 'https://edenfigma.netlify.app/static/media/header-img.559f8a316b7a009a3a53.png',
      // placeholderSrc:
      //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://app.netlify.com/sites/edenfigma/',
    },
    technologies: [
      '#react',
      '#css',
      // '#mobx-keystone',
      // '#i18next',
      '#firebase-analytics',
      // '#google-maps',
    ],
  },
  {
    id: '3',
    title: 'Outfit',
    description:
      'A react native app with animations made with react-native-reanimated. The app is based on the Outfitr - Fashion UI Kit.',
    image: {
      src: 'https://edenmillonaira.netlify.app/static/media/Who-Wants-To-Be-A-Millionaire-3.2a0ad0b1.png',
      // placeholderSrc:
      //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://edenmillonaira.netlify.app/',
      repo: 'https://github.com/EdenBrowny/who_wants_to_be_a_millonaire',
    },
    technologies: [
      '#react',
      '#css',
      // '#expo',
      // '#react-native-reanimated',
      '#react-navigation',
    ],
  },
  {
    id: '4',
    title: 'Weather App',
    description:
      'This is a weather app that dectates the weather condition of a particular location by simply selecting the location option and clicking the search button.',
    image: {
      src: 'data:image/jpeg;base64,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',
      // placeholderSrc:
      //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://petweather.netlify.app/',
      repo: 'https://github.com/EdenBrowny/myweather-app',
    },
    technologies: [
      '#react',
      // '#redux',
      // '#socket.io',
      '#css',
      // '#formik',
      // '#react-window',
      '#restapi',
    ],
  },
  {
    id: '5',
    title: 'Edens-fast-food',
    description:
      'A MERN app to let users share their experience of places along with Details. It is user friendly and can be useful to many others.',
    image: {
      src: 'https://edens-fast-food.netlify.app/static/media/welcome.d724eb984456d9c97470.png',
      // placeholderSrc:
      //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://edens-fast-food.netlify.app/',
      repo: 'https://github.com/EdenBrowny/mybuild',
    },
    technologies: [
      '#react',
      '#nodejs',
      '#express',
      '#mongodb',
      // '#react-query',
      // '#react-transition-group',
      '#mongoose',
      // '#jwt',
      // '#aws',
    ],
  },
  {
    id: '6',
    title: 'Travel Site',
    description:
      'This is a travel site that helps describe the feel of a place even before people get there.',
    image: {
      src: 'https://edens-tour.netlify.app/static/media/images_04.9229a68eb35ca300cc7b.jpg',
      // placeholderSrc:
      //   'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
    },
    links: {
      site: 'https://edens-tour.netlify.app/',
      repo: 'https://github.com/EdenBrowny/my-travel-app',
    },
    technologies: [
      '#react',
      '#css',
      // '#redux',
      // '#redux-toolkit',
      // '#react-navigation',
      // '#nodejs',
      // '#express',
      // '#mongodb',
    ],
  },
  // {
  //   id: '7',
  //   title: 'Places Mobile App',
  //   description:
  //     'A Mobile application for sharing places that people visit from all over the world. Uses React Native, TypeScript, MobX and Native Device Features',
  //   image: {
  //     src: 'https://res.cloudinary.com/dx6tl6aa2/image/upload/v1628348073/portfolio/projects/rn-places/rn-places-lg_ljyikm.jpg',
  //     placeholderSrc:
  //       'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
  //   },
  //   links: {
  //     site: 'https://expo.dev/@v_snaichuk/rn-places',
  //     repo: 'https://github.com/vsnaichuk/RN-places',
  //   },
  //   technologies: [
  //     '#react-native',
  //     '#typescript',
  //     '#expo',
  //     '#mobx',
  //     '#sqlite',
  //     '#react-native-maps',
  //     '#expo-location',
  //   ],
  // },
  // {
  //   id: '8',
  //   title: 'Shopping Cart',
  //   description:
  //     'Simple eCommerce cart application built with React and TypeScript. Uses SWR hook to fetch the data from the API and Styled Components',
  //   image: {
  //     src: 'https://res.cloudinary.com/dx6tl6aa2/image/upload/v1628348073/portfolio/projects/react-shop-cart/rn-shop-cart-lg_w3qxn6.jpg',
  //     placeholderSrc:
  //       'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzIDIiPjwvc3ZnPg==',
  //   },
  //   links: {
  //     site: 'https://shopping-cart-sv.netlify.app/',
  //     repo: 'https://github.com/vsnaichuk/React-ShoppingCart',
  //   },
  //   technologies: [
  //     '#react',
  //     '#typescript',
  //     '#material-ui',
  //     '#styled-components',
  //     '#swr',
  //     '#fakestoreapi',
  //   ],
  // },
];

export default data;
